import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import {
  AddStageRequest,
  CaseStageAction,
  CaseStageEnum,
} from "../../../../../src/api/caseStages";
import { useAppDispatch } from "../../../../../src/app/hooks";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";
import StageWorkflowAssignOfficerModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowAssignOfficerModal";
import { useAppSelector } from "../../../../app/store";
import { showErrorToast, showSuccessToast } from "../../../../lib/toast";
import { getDealingOfficers } from "../../../users/logic/slice";
import { fetchDealingOfficers } from "../../../users/logic/thunk";
import { updateCaseStage } from "../../logic/thunks";
import { sortOptions } from "../../../../lib/utils";

export const AssignDO: React.FC<{
  next_stage: CaseStageEnum;
}> = ({ next_stage }) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();
  const dealingOfficers = useAppSelector(getDealingOfficers);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetchingDealingOfficers, setIsFetchingDealingOfficers] =
    useState(false);

  const dealingOfficerOptions = sortOptions(
    dealingOfficers?.map((user) => ({ 
      name: user.user_name || "", 
      value: user.user_id || user.email_id || "" 
    })) ?? []
  );        

  useEffect(() => {
    if (dealingOfficers.length === 0) {
      setIsFetchingDealingOfficers(true);
      dispatch(fetchDealingOfficers()).finally(() => {
        setIsFetchingDealingOfficers(false);
      });
    }
  }, [dealingOfficers.length, dispatch]);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    setIsModalOpen(false);
  };

  const handleConfirmAssign = async (
    selectedDealingOfficer: string,
  ): Promise<void> => {
    if (!caseId || !selectedDealingOfficer) return;
    try {
      setIsLoading(true);

      const request: AddStageRequest = {
        stage: next_stage,
        source_action: CaseStageAction.ASSIGN_DO,
        stage_data: {
          dealing_authority: selectedDealingOfficer,
        },
      };

      await dispatch(
        updateCaseStage({
          caseId,
          request,
        }),
      ).unwrap();

      showSuccessToast("Dealing Officer has been assigned successfully.");
      setIsModalOpen(false);
    } catch (error) {
      showErrorToast("Unable to assign the Dealing Officer. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AcceptButton label="Assign" onClick={handleOpen} />

      <StageWorkflowAssignOfficerModal
        isOpen={isModalOpen}
        options={dealingOfficerOptions}
        onClose={handleClose}
        onConfirm={handleConfirmAssign}
        title="Appoint Dealing Officer"
        loading={isLoading}
        isFetchingOptions={isFetchingDealingOfficers}
      />
    </>
  );
};
